import { conns } from '@cfg/axiosConfig.tsx';
import { Coupon, CouponBulkParams } from '@eshop/types/dashboard/coupon.types.ts';

const URL = 'eshop:dashboard:coupons';

export const CouponsApi = {
  async list(): Promise<Coupon[]> {
    const { data } = await conns<Coupon[]>(URL).get();
    return data;
  },
  async create(payload: Partial<Coupon>): Promise<Coupon> {
    const { data } = await conns<Coupon>(URL).post(payload);
    return data;
  },
  async update(id: number, payload: Partial<Coupon>): Promise<Coupon> {
    const { data } = await conns<Coupon>(URL, [id]).put(payload);
    return data;
  },
  async bulkGenerate(payload: CouponBulkParams): Promise<{ codes: string[] }> {
    const { data } = await conns<{ codes: string[] }>(`${URL}/bulk`).post(payload);
    return data;
  },
};
